<!--  -->
<template>
  <div class="details">
      <Header class="header" title="事件记录" :isRightIcon="isRightIcon" :isLeftIcon="data.state === 1? false:true" @back="$emit('back')" @closeBtn="$emit('closeBtn')"/>
      <div class="wrap">
        <div class="describe">
          {{ data.eventTitle }}
        </div>
        <div class="header">
          <div class="title">{{ data.storeName }}</div>
          <div class="time">{{ data.createTime | setDate }}</div>
        </div>
      </div>

      <div class="select-wrap">
        <div :class="{ active: type }" @click="informationBtn">基本信息</div>
        <div :class="{ active: !type }" @click="recordBtn">跟进记录</div>
      </div>

      <div class="event-wrap" v-if="type">
        <div
          class="item"
          v-for="(item, index) in data.eventItems"
          :key="item.id"
        >
          <div class="title">
            <div class="index">{{ index + 1 }}</div>
            <div class="category">{{ item.describle }}</div>
          </div>
          <div class="describe">{{ item.scoreContent }}</div>
          <div class="split-line" v-if="item.comment"></div>
          <div class="remarks" v-if="item.comment">
            备注:{{ item.comment ? item.comment : "无" }}
          </div>
          <ImgList v-if="item.images" :images="item.images" />
        </div>
      </div>

      <div class="record-wrap" v-else>
        <div v-if="data.eventFollowUps.length">
          <div class="item" v-for="item in data.eventFollowUps" :key="item.id">
            <div class="header">
              <div>{{ item.createTime | setTime }}跟进结果</div>
              <div class="see-details" @click="$emit('goDetailsClick',item)">
                查看详情>
              </div>
            </div>
            <div class="describe">{{ item.memo }}</div>
            <div class="footer">
              <div>跟进人: {{ item.creator }}</div>
              <div class="time">{{ item.createTime | setDate  }}</div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          <img src="../../../assets/image/no_order.png" alt="" />
          暂时没有跟进记录
        </div>
      </div>
    </div>
    <!-- <FollowUpDetails v-else @back="back"></FollowUpDetails> -->
</template>

<script>
import moment from "moment";
import Header from "./header.vue";
import FollowUpDetails from "./FollowUpDetails";
import ImgList from "../../../components/imgList";
export default {
  props: ["data","isRightIcon","type"],
  // data() {
  //   return {
  //     // type: true,

  //     // isFollowUpDetails: false,
  //   };
  // },

  components: {
    Header,
    FollowUpDetails,
    ImgList,
  },
  filters: {
    setDate(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    setTime(val) {
      return moment(val).format("MM月DD日");
    },
  },
  methods: {
    // back() {
    //   this.isFollowUpDetails = false;
    // },
    informationBtn() {
      this.$emit("setDetailsType",true)
      // this.type = true;
    },
    recordBtn() {
      this.$emit("setDetailsType",false)
      // this.type = false;
    },
    // goDetailsClick() {
    //   this.isFollowUpDetails = true;
    // },
  },
};
</script>
<style lang='less' scoped>
.details {
  background-color: #f4f5f7;
  width: 100%;
  // height: 100%;
}

.wrap {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202636;
  padding: 16px;
  // background-color: red;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 12px;
    color: #74879b;
    font-size: 12px;
    .time {
      // background-color: red;
      width: 120px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #74879b;
    }
  }
  .describe {
    margin-bottom: 6px;
    // font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // color: #4a5462;
  }
}
.select-wrap {
  padding: 12px 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a5462;
  .active {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    border-bottom: 3px solid #428ff8;
    font-weight: 600;
    color: #202636;
  }
}

.event-wrap {
  padding: 0 12px;
  // &::-webkit-scrollbar {
  //   width: 4px;
  //   height: 1px;
  // }
  // &::-webkit-scrollbar-track {
  //   border-radius: 4.5px;
  //   background: #ededed;
  // }
  // &::-webkit-scrollbar-thumb {
  //   background: #b1b9ce;
  //   border-radius: 4.5px;
  // }
  .item {
    // background-color: red;
    background-color: #fff;
    border: 2px solid #e7f1fe;
    border-radius: 10px;
    padding: 16px 32px;
    margin-bottom: 8px;
    position: relative;
    .title {
      margin-bottom: 8px;
      // display: flex;
      .index {
        width: 25px;
        height: 20px;
        background: #00cca2;
        border-radius: 0px 4px 4px 0px;
        text-align: center;
        line-height: 20px;
        margin-right: 7px;
        position: absolute;
        left: 0;
      }
      .category {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #202636;
      }
    }
  }
  .describe {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #428ff8;
    word-break:break-all; 
  }
  .split-line {
    width: 100%;
    height: 1px;
    margin: 8px 0;
    background: #ecf3fc;
  }
  .remarks {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #74879b;
  }
}
.record-wrap {
  padding: 0 12px;
  // &::-webkit-scrollbar {
  //   width: 4px;
  //   height: 1px;
  // }
  // &::-webkit-scrollbar-track {
  //   border-radius: 4.5px;
  //   background: #ededed;
  // }
  // &::-webkit-scrollbar-thumb {
  //   background: #b1b9ce;
  //   border-radius: 4.5px;
  // }
  .item {
    border: 2px solid #e7f1fe;
    border-radius: 10px;
    background-color: #fff;
    overflow: hidden;
    // padding: 16px 32px;
    margin-bottom: 8px;
    .header {
      padding: 12px 18px;
      background: linear-gradient(180deg, #ffffff 0%, #fafbfb 100%);
      // background-color: red;
      // height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202636;
      .see-details {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #74879b;
      }
    }
    .describe {
      padding: 14px 17px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202636;
      white-space: pre-wrap	;
      word-break: break-all;
    }
    .footer {
      padding: 12px 18px;
      // margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4a5462;
      .time {
        width: 155px;
        // background-color: red;
        color: #74879b;
      }
    }
  }
  .no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #74879b;
    img {
      width: 111px;
      height: 80px;
    }
  }
}
</style>